const startsWithJsonContainer = (value: string) => {
  const trimmedValue = value.trim();

  return trimmedValue.startsWith('{') || trimmedValue.startsWith('[');
};

const reviver = (_: string, value: unknown): unknown => {
  if (typeof value === 'string' && startsWithJsonContainer(value)) {
    try {
      return JSON.parse(value, reviver);
    } catch {
      return value;
    }
  }
  return value;
};

const formatJsonPayload = (
  payload?: string | null,
): { code: string; language: string } => {
  if (!payload) {
    return {
      code: '',
      language: '',
    };
  }

  if (!startsWithJsonContainer(payload)) {
    return {
      code: payload,
      language: '',
    };
  }

  try {
    return {
      code: JSON.stringify(JSON.parse(payload, reviver), null, 2),
      language: 'json',
    };
  } catch {
    return {
      code: payload,
      language: '',
    };
  }
};

export default formatJsonPayload;
